<script setup lang="ts">
const { data: page } = await useAsyncData('about', () => queryCollection('about').first())

if (!page.value) {
  throw createError({ statusCode: 404, statusMessage: 'Page not found', fatal: true })
}

const title = page.value.seo?.title || page.value.title
const description = page.value.seo?.description || page.value.description

useSeoMeta({
  title,
  ogTitle: title,
  description,
  ogDescription: description
})

defineOgImageComponent('Saas')

// The canonical "what is mychar.gg" page: AboutPage type. Publisher auto-links
// to the sitewide Organization defined in app.vue.
useSchemaOrg([
  defineWebPage({ '@type': 'AboutPage' })
])
</script>

<template>
  <div v-if="page">
    <UPageHero
      :title="page.title"
      :description="page.description"
    />

    <UContainer>
      <div class="max-w-3xl mx-auto pb-24 prose prose-invert dark:prose-invert">
        <ContentRenderer
          v-if="page.body"
          :value="page"
        />
      </div>
    </UContainer>
  </div>
</template>
